module.exports = __webpack_public_path__ + "images/background/image_thumbnail/3-off-158f38ba975a6148171c9956c9ac2fbf.jpg";